module.exports = {
      id: "ic-crosshair-off-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "sprite-dfad78.smartcharts.svg#ic-crosshair-off-usage",
      toString: function () {
        return this.url;
      }
    }